// src/components/LogoutButton.tsx
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, message } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { logout } from '../data/auth';
import { clearAuthState } from '../redux/authSlice';
import type { AppDispatch } from '../redux';

const LogoutButton: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();

    const handleLogout = async () => {
        setLoading(true);
        try {
            await logout();
            dispatch(clearAuthState());
            message.success('Logged out successfully');
            navigate('/login');
        } catch (err: any) {
            message.error(err.message || 'Logout failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            icon={<LogoutOutlined />}
            onClick={handleLogout}
            loading={loading}
            type="link"
            danger
        >
            Logout
        </Button>
    );
};

export default LogoutButton;
